import {ERROR_ACTIONS} from "../actions/types";

export default (state = [], {type, message}) => {
	switch (type) {
		case ERROR_ACTIONS.ADD:
			return [...state, message];
		case ERROR_ACTIONS.DISMISS:
			const length = state.length;
			if ( length ) {
				// state.pop();
				// return [...state];
				return state.filter((_, index) => index + 1 !== length);
			}
			return [];
		case ERROR_ACTIONS.CLEAR_ALL:
			return [];
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js